import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

import types from '../store/globaltypes'
import toolbar from '../components/toolbar'
import bottomnav from '../components/bottomnav'
import infobar from '../components/infobar'
import authService from '../services/AuthService'
import notificationService from '../services/NotificationService'
import { isMobileApp } from '../helpers/platform'

export default {
  name: 'app',
  components: { toolbar, bottomnav, infobar },
  props: [],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      user: types.user.getters.currentUser,
      locale: types.user.getters.localeCode
    }),
    ...mapState({
      calendarCollapsed: state => state.ui.calendar.calendarCollapsed
    })
  },
  mounted () {
    if (isMobileApp()) {
      navigator.splashscreen.hide()
    }
    this.setLocale(localStorage.getItem('locale') || 'nl')
    this.fillI18n()
    authService.setupAuthHandler(this.$router, this.$store)
    notificationService.setupNotificationHandler(this.$router, this.$store, this.$t('ui.welcome_message_title'))
    notificationService.sendWelcomeMessage(this.$t('ui.welcome_message_title'), this.$t('ui.welcome_message'))
  },
  methods: {
    ...mapMutations({
      setUser: types.user.mutations.set
    }),
    ...mapActions({
      fillI18n: types.i18n.actions.fill,
      setLocale: types.user.actions.setLocale
    })
  },
  watch: {
    user: function (val) {
      if (!val) this.$router.push({ name: 'login' })
    }
  }
}
